"use strict";

exports.__esModule = true;
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const UserSearchCircleIcon = ({
  title,
  ...otherProps
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    xmlns: "http://www.w3.org/2000/svg",
    ...otherProps,
    children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M54.39 64.791a33.835 33.835 0 01-18.1 5.213c-18.776 0-33.998-15.222-33.998-34 0-18.777 15.222-34 33.999-34 18.776 0 34 15.223 34 34A33.842 33.842 0 0163.42 56.5",
        stroke: "#fefefe",
        strokeWidth: 3.5,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "svg-stroke-secondary"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M31.84 34.43a5.724 5.724 0 1111.448 0 5.724 5.724 0 01-11.448 0z",
        stroke: "#fefefe",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "svg-stroke-secondary"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M27.746 52.217h19.635V50.15c0-5.422-4.396-9.818-9.818-9.818s-9.817 4.396-9.817 9.818c0 0 .071 2.066 0 2.066z",
        stroke: "#fefefe",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "svg-stroke-secondary"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M15.118 52.174h0c1.8 1.8 4.717 1.8 6.517 0l7.442-7.315-3.311-3.206-10.648 10.52z",
        stroke: "#4caa50",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "svg-stroke-primary"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M37.322 19.504c-7.656 0-13.862 6.206-13.862 13.862 0 7.657 6.206 13.863 13.862 13.863s13.862-6.206 13.862-13.863c0-7.656-6.206-13.862-13.862-13.862z",
        stroke: "#4caa50",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "svg-stroke-primary"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M57.382 60.451a1.827 1.827 0 113.653.002 1.827 1.827 0 01-3.653-.002",
        fill: "#fefefe",
        className: "svg-fill-secondary"
      })]
    })]
  });
};

UserSearchCircleIcon.defaultProps = {
  title: undefined
};

var _default = (0, _styles.colourIcon)(UserSearchCircleIcon);

exports.default = _default;